import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useRoomSelection = (availableRooms, halfPayRule, setAvailableRooms) => {
    const [selectedRooms, setSelectedRooms] = useState([]);
    const { t } = useTranslation();

    const handleRoomSelection = (action, room, ratePlan, roomIndex, ratePlanIndex) => {
        const roomItem = {
            roomId: room.room_type_id,
            name: room.room_type_name,
            capacity: room.room_type_capacity,
            extraCapacity: room.room_type_extra_capacity,
            planId: ratePlan.id,
            planName: ratePlan.name,
            prices: ratePlan.prices,
            halfPayRule
        };

        const isRoomSelected = selectedRooms.some(item => item.roomId === room.room_type_id && item.planId === ratePlan.id);

        if (action === "add") {
            addRoom(roomItem, room, ratePlan, roomIndex, ratePlanIndex, isRoomSelected);
        } else if (action === "remove") {
            removeRoom(roomItem, room, ratePlan, roomIndex, ratePlanIndex, isRoomSelected);
        }
    };

    const addRoom = (roomItem, room, ratePlan, roomIndex, ratePlanIndex, isRoomSelected) => {
        if (availableRooms[roomIndex]?.rate_plans[ratePlanIndex].count < ratePlan.prices.inventory) {
            updateAvailableRooms(roomIndex, ratePlanIndex, 1);
            updateSelectedRooms(roomItem, room, ratePlan, isRoomSelected, 1);
        } else {
            toast.error(t("hotelMessage2"), { toastId: "custom-id-yes" });
        }
    };

    const removeRoom = (roomItem, room, ratePlan, roomIndex, ratePlanIndex, isRoomSelected) => {
        updateAvailableRooms(roomIndex, ratePlanIndex, -1);
        updateSelectedRooms(roomItem, room, ratePlan, isRoomSelected, -1);
    };

    const updateAvailableRooms = (roomIndex, ratePlanIndex, change) => {
        setAvailableRooms(rooms =>
            rooms.map((room, i) =>
                i === roomIndex
                    ? {
                          ...room,
                          rate_plans: room.rate_plans.map((plan, j) => (j === ratePlanIndex ? { ...plan, count: plan.count + change } : plan)),
                      }
                    : room,
            ),
        );
    };

    const updateSelectedRooms = (roomItem, room, ratePlan, isRoomSelected, change) => {
        if (isRoomSelected) {
            setSelectedRooms(values =>
                values
                    .map(value =>
                        value.roomId === room.room_type_id && value.planId === ratePlan.id ? { ...value, count: value.count + change } : value,
                    )
                    .filter(value => value.count > 0),
            );
        } else if (change > 0) {
            setSelectedRooms(values => [...values, { ...roomItem, count: 1 }]);
        }
    };

    return {
        availableRooms,
        selectedRooms,
        handleRoomSelection,
    };
};
export default useRoomSelection;
